import formatCurrency from "../../../../Utils/formatCurrency"
import { NAME_SERVER } from "../../../../Utils/NAME_HOST"
import styles from "./InfoWagering.module.css"
function InfoWagering({props}){
    const {sum_bets,amount_last,amount_bonus,amount_payin,status,status_payin} = props
    console.log(amount_last)
    const colors_background = {0:"rgba(229,43,72,.15)",1:"rgb(75 229 43 / 15%)"}
    const colors_text = {0:"rgb(229 52 52)",1:"rgb(60 229 52)"}
    return (
        <div className={styles.container}>
            <div className={styles.status} style={{color:colors_text[status]}}>
                <div className={styles.circle}>{status===1?<img src={NAME_SERVER+"/assets/"+"Success.gif"} width={40}/>:<img src={NAME_SERVER+"/assets/"+"Error.gif"} width={35}/>}</div>
                {status===0?"Вывод недоступен":"Вывод доступен"}
            </div>
            <div className={styles.rule} style={{alignItems:"center"}}>
                {status_payin===0?<img src={NAME_SERVER+"/assets/"+"Error.gif"} width={30}/>:<img src={NAME_SERVER+"/assets/"+"Success.gif"} width={30}/>}
            
                Cумма депозитов больше {formatCurrency(1000,"cost")} за последние 7 дней
            </div>
            <div className={styles.rule}>
                {(amount_bonus+amount_payin)>0?<div style={{display:"flex",justifyContent:"flex-start",justifySelf:"flex-start"}}><img src={NAME_SERVER+"/assets/"+"Error.gif"} width={30}/></div>:<img src={NAME_SERVER+"/assets/"+"Success.gif"} width={30}/>}
                <div style={{display:"flex",gap:"5px",flexDirection:"column"}}>
                Выполнение отыгрыша<br/>
                <div className={styles.rulik}>{amount_bonus>0?"Отыгрыш бонусов":""}</div>
                <div className={styles.rulik}>{amount_payin>0?"Сумма последних депозитов "+" Вейджер X2":""}</div>
                <div style={{display:"flex"}}>
            {(amount_bonus+amount_payin)>0&&<div className={styles.info_wager}>Осталось отыграть: {formatCurrency(amount_bonus+amount_payin,"cost")}</div>}
            </div>
                </div>
                
                
            

            </div>
            
        </div>
    )
}
export default InfoWagering